export const useProsStore = defineStore('pros', {
  state: () => ({
    pros: null,
  }),
  actions: {
    setPros(response) {
      const {
        recommendationsProductId,
        prosZonesAddToListEnabled,
        quickViewProsZoneEnabled,
        responsiveAddToBagEnabled,
        responsiveBagNewUrlEnabled,
        prosZoneCSGRedesignScalingEnabled,
        responsiveMyAccountDesktopProsPanelEnabled,
        isMyAccountProsOnMewEnabled,
        disableApisWithUserIdInPayload,
      } = response.cards;
      this.pros = {
        recommendationsProductId,
        killswitches: {
          prosZonesAddToListEnabled,
          quickViewProsZoneEnabled,
          responsiveAddToBagEnabled,
          responsiveBagNewUrlEnabled,
          prosZoneCSGRedesignScalingEnabled,
          responsiveMyAccountDesktopProsPanelEnabled,
          isMyAccountProsOnMewEnabled,
          disableApisWithUserIdInPayload,
        },
      };
    },
  },
});
